/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql, StaticQuery, Link } from "gatsby";
import parse, { domToReact } from "html-react-parser";
import cx from "classnames";
import { Nav } from "./nav";
const options = {
  replace: (domNode) => {
    // if(domNode.name === 'a' && domNode.attribs?.href?.startsWith('/')) {

    //   return <Link to={domNode.attribs.href}>{domToReact(domNode.children, options)}</Link>
    // }

    if (domNode.name === "form" && domNode.attribs.class === "search-form") {
      return (
        <form
          role="search"
          method="get"
          className="search-form"
          action={`${process.env.GATSBY_PATH_PREFIX || ""}/search`}
        >
          {domToReact(domNode.children, options)}
        </form>
      );
    }
    return domNode;
  },
};
const Header = ({ children, blog, dark }) => {
  return <Nav dark={dark || false} />;
  // return (
  //   <StaticQuery
  //     query={graphql`
  //       query HeadingQuery {
  //         wpPages {
  //           header
  //         }
  //         wpPosts {
  //           blogHeader
  //         }
  //       }
  //     `}
  //     render={(data) => {
  //       const header = parse(data.wpPages.header.trim(), options);
  //       return (
  //         <>
  //           {React.cloneElement(header, {
  //             className: cx(header.props.className, {
  //               "is-blog": blog,
  //               dark: dark,
  //             }),
  //           })}
  //           {blog && parse(data.wpPosts.blogHeader, options)}
  //         </>
  //       );
  //     }}
  //   />
  // );
};

Header.propTypes = {
  children: PropTypes.node,
};

export default Header;
